import React from "react";

import SchedulerWeeks from "2g-scheduler-weeks";
import { Controlled } from "2g-form";

import useSchedulerWeeks from "./useSchedulerWeeks";
import ContentRenderer from "./ContentRenderer";
import PeriodYearControlled from "./PeriodYearControlled";

export function SchedulerWeeksComponent() {
  const { values, resolveItemState } = useSchedulerWeeks();

  return values.platnostOd &&
    values.platnostDo &&
    ((values.defaultMzo && values.defaultVzo) || values.fixniNaroky) ? (
    <>
      <Controlled
        component={PeriodYearControlled}
        path="_period"
        min={new Date(values.platnostOd).getFullYear()}
        max={new Date(values.platnostDo).getFullYear()}
        defaultValue={{ yearFrom: new Date(values.platnostOd).getFullYear() }}
      />
      {values._period && values._period.yearFrom && (
        <SchedulerWeeks
          dateFrom={new Date(values.platnostOd)}
          dateTo={new Date(values.platnostDo)}
          contentRenderer={ContentRenderer}
          resolveItemState={resolveItemState}
        />
      )}
    </>
  ) : null;
}

SchedulerWeeksComponent.propTypes = {};

export default React.memo(SchedulerWeeksComponent);
